"use client";

// Flag-gated note beneath the Starter/Pro/Business comparison table.
// Points multi-site principal contractors to Site Control, the per-site
// enterprise tier above Business. Renders only when the `site_control`
// feature flag is live (DB-backed flag, surfaced via the provider that
// wraps the pricing page). Kept as a small client child so the comparison
// table itself stays a server component with no flag plumbing.

import Link from "next/link";
import { useAppFeatureFlag } from "@/components/feature-flags/feature-flags-provider";
import {
  SITE_CONTROL_NAME,
  SITE_CONTROL_PRICE_HEADLINE,
} from "@/lib/site-control-copy";

export function SiteControlComparisonNote() {
  const flagEnabled = useAppFeatureFlag("site_control");

  // Off (or undefined) → render nothing.
  if (flagEnabled !== true) return null;

  return (
    <p className="mt-6 text-center text-[11px] leading-snug text-muted sm:text-sm">
      Running live sites with subcontractors? {SITE_CONTROL_NAME} is the tier
      above Business: per active site with unlimited workers, entrance QR
      sign-in, CSCS checks and audit-grade exports. {SITE_CONTROL_PRICE_HEADLINE}.{" "}
      <Link href="/site-control" className="font-semibold text-brand-700 hover:text-accent-dark">
        Book a walkthrough
      </Link>
      .
    </p>
  );
}
